enum SortWorkHoursByType {
  FAVORITE = 'FAVORITE',
  LAST_ADDED = 'LAST_ADDED'
}

export default SortWorkHoursByType